// Coalesce edits and serialize writes per anchor so slow saves cannot win over newer edits.
export function createVwapAppearanceAutosave(save, onStatus, delay = 400) {
  const entries = new Map()
  function entryFor(id) {
    if (!entries.has(id)) entries.set(id, { version: 0, saved: 0, timer: null, running: null })
    return entries.get(id)
  }
  async function flush(id) {
    const entry = entryFor(id)
    clearTimeout(entry.timer)
    entry.timer = null
    if (entry.running) {
      await entry.running
      if (entry.saved < entry.version) return flush(id)
      return
    }
    if (entry.saved === entry.version) return
    const version = entry.version
    const value = { ...entry.value }
    onStatus(id, 'Saving…')
    entry.running = (async () => {
      try {
        if (await save(id, value) === false) throw new Error('Save refused')
        entry.saved = version
        if (version === entry.version) onStatus(id, 'Saved')
      } catch {
        if (version === entry.version) onStatus(id, 'Could not save')
      }
    })()
    await entry.running
    entry.running = null
    if (version !== entry.version && !entry.timer) return flush(id)
  }
  return {
    edit(id, value) {
      const entry = entryFor(id)
      entry.value = { ...value }
      entry.version++
      clearTimeout(entry.timer)
      onStatus(id, 'Saving…')
      entry.timer = setTimeout(() => { entry.timer = null; void flush(id) }, delay)
    },
    flush,
    flushAll() { return Promise.all([...entries.keys()].map(flush)) },
  }
}
